module.exports = __webpack_public_path__ + "img/logo.598efa81.png";